module.exports = __webpack_public_path__ + "img/voucher_icon_1.066b12be.svg";